enum ProductType {
  Article = 0,
  PreWeighed = 1,
  UserWeighed = 2,
}

export default ProductType;
